var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{attrs:{"name":"warning","color":"error"}},[_vm._v("mdi-alert")]),_c('span',{staticClass:"error-text ml-1 semiBold"},[_vm._v("ADVERTENCIA")])],1),_c('span',[_vm._v(" A partir de este punto, ya no se podrá modificar esta propuesta. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }